export function checkWin(houses: THouseState[]): boolean {
	return Object.values(houses).every((h) => h.covered);
}
